"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = _default;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _useDialog2 = _interopRequireDefault(require("../hooks/useDialog2"));

var _react = _interopRequireWildcard(require("react"));

var _QdLearningSeriesView = _interopRequireDefault(require("../views/QdLearningSeriesView"));

var _SeriesContextProvider = require("../context/SeriesContextProvider");

var _TypeToReactComponent = require("../helpers/TypeToReactComponent");

function _default(props) {
  var _useDialog = (0, _useDialog2["default"])(props),
      readySubDialogs = _useDialog.readySubDialogs;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      currentSubDialogs = _useState2[0],
      setCurrentSubDialogs = _useState2[1];

  var _ref = (0, _SeriesContextProvider.useSeriesContext)(),
      curDialogIndex = _ref.curDialogIndex,
      setCurDialogIndex = _ref.setCurDialogIndex;

  function goToNextDialog() {
    setCurDialogIndex(function (index) {
      return index + 1;
    });
  }

  (0, _react.useEffect)(function () {
    setCurDialogIndex(0);
  }, []);
  (0, _react.useEffect)(function () {
    var tempCurrentSubDialogs = [];
    readySubDialogs.forEach(function (dialog) {
      tempCurrentSubDialogs.push(dialog);
    });
    setCurrentSubDialogs(tempCurrentSubDialogs);
  }, [readySubDialogs]);
  return /*#__PURE__*/_react["default"].createElement(_QdLearningSeriesView["default"], null, currentSubDialogs.map(function (dialog) {
    return (0, _TypeToReactComponent.getComponent)(dialog, {
      goToNextDialog: goToNextDialog
    });
  }));
}